import { getExperimentParam } from 'src/utils/experimentNew'

export const FeatureFlags = {
  /**
   * Stage 2 dual-mode SSR/CSR rollout (see
   * `.claude/docs/ssr-rollout-strategy.md` 方案 B and
   * https://mewtant-inc.sg.larksuite.com/wiki/FDUXwghGyiDJHTkQKYPlyategvg).
   *
   * - `'off'` (default) — every dual-mode route renders its CSR entry
   *   under `<RootRuntime>` with no SSR seed (equivalent to Stage 1
   *   behaviour). This is also what `main` ships before Amplitude is
   *   configured.
   * - `'on'`            — every dual-mode route renders its Full SSR
   *   entry, exposing route-scoped Apollo seed + `initial*` props +
   *   JSON-LD / `<h1>` to the first SSR flush.
   *
   * MUST be consumed via `useHydratedFeatureFlag` /
   * `getHydratedFeatureFlag` (SSR-safe, server + client share the
   * variant injected by `experimentMiddleware` — see PR #10120).
   * Reading via the regular `useFeatureFlag` hook would tear
   * hydration because that hook is client-only and returns `false`
   * during SSR.
   */
  SsrDualMode: 'pixai-app-full-ssr',
} as const
export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags]

export async function getFeatureFlag(name: FeatureFlag) {
  const result = await getExperimentParam<'on' | 'off'>(name)
    // Fallback to 'off' in case of any error
    .catch(() => 'off')
  return result === 'on'
}
